export const Status = {
  ACTIVE: "Active",
  INPROGRESS: "In progress",
  BLOCKED: "Blocked",
  SUSPENDED: "Suspended",
  PENDING: "Pending",
  NOTACTIVE: "Not active",
  TEST: "Test account",
  NEW: "New",
  NEWPLUS: "Ready for creation",
  COMPLETED: "Completed",
  WAITINGONAPIKEYS: "Waiting on API keys",
  WAITINGFORCONNECTION: "Waiting for connection",
  READYFORREQUESTER: "Ready for 2nd Step",
  READYFORCREATION: "Ready for Quicklink",
  UPDATEQUICKLINK: "Update QuickLink"
};

/** SharedApp statuses that should show "page disabled" (not generic not-found). */
export function isUnavailableSharedAppStatus(status) {
  const st = String(status || "").trim().toUpperCase();
  return st === "BLOCKED" || st === "SUSPENDED" || st === "NOTACTIVE";
}

export const StatusVariant = [
    {
        type: "ACTIVE",
        variant: "success"
    },
    {
        type: "INPROGRESS",
        variant: "primary"
    },
    {
        type: "NOTACTIVE",
        variant: "warning"
    },
    {
        type: "PENDING",
        variant: "warning"
    },
    {
        type: "BLOCKED",
        variant: "danger"
    },
    {
        type: "SUSPENDED",
        variant: "danger"
    },
    {
        type: "TEST",
        variant: "info"
    },
    {
        type: "NEW",
        variant: "warning"
    },
    {
        type: "NEWPLUS",
        variant: "warning"
    },
    {
        type: "COMPLETED",
        variant: "success"
    },
    {
        type: "WAITINGONAPIKEYS",
        variant: "info"
    },
    {
        type: "WAITINGFORCONNECTION",
        variant: "info"
    },
    {
        type: "READYFORREQUESTER",
        variant: "success"
    },
    {
        type: "READYFORCREATION",
        variant: "warning"
    },
    {
        type: "UPDATEQUICKLINK",
        variant: "warning"
    }
];
